var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.997,
    height: 28.704,
    viewBox: "0 0 138.997 28.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#51499c;}.b{fill:#26a7df;}.c{fill:#d42941;}.d{fill:#f05a2a;}.e{fill:#f8b018;}.f,.g,.h,.i,.j{opacity:0.7;}.f{fill:url(#a);}.g{fill:url(#b);}.h{fill:url(#c);}.i{fill:url(#d);}.j{fill:url(#e);}.k{fill:#0b3454;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.187,
    y1: 0.533,
    x2: 0.691,
    y2: 0.465,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#231f20",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#231f20",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#231f20",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.053,
    y1: 0.5,
    x2: 0.427,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.096,
    y1: 0.647,
    x2: 0.436,
    y2: 0.503,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.017,
    y1: 0.956,
    x2: 0.504,
    y2: 0.494,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.368,
    y1: 1.302,
    x2: 0.61,
    y2: 0.048,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.382H0V2.3A2.188,2.188,0,0,1,.323,1.09,2.09,2.09,0,0,1,2.18,0,2.571,2.571,0,0,1,3.27.283,2.087,2.087,0,0,1,4.32,1.817V4.2L0,6.742Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.04,16.333C.04,15.687,0,15,0,14.315V11.327L8.276,6.563a2.1,2.1,0,0,0,.2-.121h.04A2.563,2.563,0,0,1,9.608,6.2a1.373,1.373,0,0,1,.4.04h.081a2.168,2.168,0,0,1,.606,4l-.081.04-1.292.686Z",
    transform: "translate(0 -3.697)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.9,23.9Z",
    transform: "translate(-23.196 -14.251)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.886,26.455l-.121-.363A17.9,17.9,0,0,1,.2,21.813l13.242-7.63h.04a.622.622,0,0,1,.283-.121,2.492,2.492,0,0,1,.888-.161H14.9a.364.364,0,0,1,.2.04c.081,0,.121.04.2.04h0c.04,0,.121.04.161.04s.04.04.081.04l.04.04a2.183,2.183,0,0,1,1.252,1.978,2.238,2.238,0,0,1-.929,1.776L13.28,19.35Z",
    transform: "translate(-0.119 -8.288)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5.386,38.265c-.04-.04-.081-.04-.121-.081A8.087,8.087,0,0,1,2.6,34.834l13.444-7.751a.141.141,0,0,1,.081-.04h.04a2.051,2.051,0,0,1,.969-.242h.121a2.361,2.361,0,0,1,.767.161,2.154,2.154,0,0,1,1.292,1.978,2.212,2.212,0,0,1-1.171,1.938L5.386,38.265Z",
    transform: "translate(-1.55 -15.981)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.064,48.267a10.128,10.128,0,0,1-4.764-1.05l10.174-5.894a4.443,4.443,0,0,1,.484-.242A1.717,1.717,0,0,1,22.4,41h.242a2.726,2.726,0,0,1,.565.081,2.158,2.158,0,0,1,1.574,1.857v.242a2.191,2.191,0,0,1-.565,1.453,6.028,6.028,0,0,1-.565.484h-.04c-.04.04-.04.04-.081.04l-3.27,1.857a2.833,2.833,0,0,0-.444.283h0A8.222,8.222,0,0,1,16.064,48.267Z",
    transform: "translate(-6.738 -24.448)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.382H0V2.3A2.188,2.188,0,0,1,.323,1.09,2.09,2.09,0,0,1,2.18,0,2.571,2.571,0,0,1,3.27.283,2.087,2.087,0,0,1,4.32,1.817V4.2L0,6.742Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.04,16.333C.04,15.687,0,15,0,14.315V11.327L8.276,6.563a2.1,2.1,0,0,0,.2-.121h.04A2.563,2.563,0,0,1,9.608,6.2a1.373,1.373,0,0,1,.4.04h.081a2.168,2.168,0,0,1,.606,4l-.081.04-1.292.686Z",
    transform: "translate(0 -3.697)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.9,23.9Z",
    transform: "translate(-23.196 -14.251)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.886,26.455l-.121-.363A17.9,17.9,0,0,1,.2,21.813l13.242-7.63h.04a.622.622,0,0,1,.283-.121,2.492,2.492,0,0,1,.888-.161H14.9a.364.364,0,0,1,.2.04c.081,0,.121.04.2.04h0c.04,0,.121.04.161.04s.04.04.081.04l.04.04a2.183,2.183,0,0,1,1.252,1.978,2.238,2.238,0,0,1-.929,1.776L13.28,19.35Z",
    transform: "translate(-0.119 -8.288)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5.386,38.265c-.04-.04-.081-.04-.121-.081A8.087,8.087,0,0,1,2.6,34.834l13.444-7.751a.141.141,0,0,1,.081-.04h.04a2.051,2.051,0,0,1,.969-.242h.121a2.361,2.361,0,0,1,.767.161,2.154,2.154,0,0,1,1.292,1.978,2.212,2.212,0,0,1-1.171,1.938L5.386,38.265Z",
    transform: "translate(-1.55 -15.981)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.064,48.267a10.128,10.128,0,0,1-4.764-1.05l10.174-5.894a4.443,4.443,0,0,1,.484-.242A1.717,1.717,0,0,1,22.4,41h.242a2.726,2.726,0,0,1,.565.081,2.158,2.158,0,0,1,1.574,1.857v.242a2.191,2.191,0,0,1-.565,1.453,6.028,6.028,0,0,1-.565.484h-.04c-.04.04-.04.04-.081.04l-3.27,1.857a2.833,2.833,0,0,0-.444.283h0A8.222,8.222,0,0,1,16.064,48.267Z",
    transform: "translate(-6.738 -24.448)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,2.382H0V2.3A2.188,2.188,0,0,1,.323,1.09,2.09,2.09,0,0,1,2.18,0,2.571,2.571,0,0,1,3.27.283,2.087,2.087,0,0,1,4.32,1.817v.646l-.04,1.776L0,6.742Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.04,16.333C.04,15.687,0,15,0,14.315V11.327L8.236,6.563a2.1,2.1,0,0,0,.2-.121h.04A2.563,2.563,0,0,1,9.568,6.2a1.373,1.373,0,0,1,.4.04h.081a2.168,2.168,0,0,1,.606,4l-.081.04-1.252.686Z",
    transform: "translate(0 -3.697)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.886,26.4l-.121-.363A17.9,17.9,0,0,1,.2,21.753l13.2-7.63h0l.081-.04a.622.622,0,0,1,.283-.121,2.492,2.492,0,0,1,.888-.161H14.9a.364.364,0,0,1,.2.04c.081,0,.121.04.2.04h0c.04,0,.121.04.161.04s.04.04.081.04l.04.04a2.183,2.183,0,0,1,1.252,1.978,2.238,2.238,0,0,1-.929,1.776L13.28,19.25Z",
    transform: "translate(-0.119 -8.229)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M5.386,38.206c-.04-.04-.081-.04-.121-.081A8.087,8.087,0,0,1,2.6,34.774l13.444-7.751a.125.125,0,0,0,.081-.04h0l.04-.04a2.051,2.051,0,0,1,.969-.242H17.3a2.361,2.361,0,0,1,.767.161h.04a2.154,2.154,0,0,1,1.292,1.978,2.212,2.212,0,0,1-1.171,1.938L5.386,38.206Z",
    transform: "translate(-1.55 -15.921)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16.064,48.267a10.128,10.128,0,0,1-4.764-1.05l10.174-5.894a4.443,4.443,0,0,1,.484-.242A1.717,1.717,0,0,1,22.4,41h.242a1.514,1.514,0,0,1,.444.04l.121.04a2.158,2.158,0,0,1,1.574,1.857v.242a2.191,2.191,0,0,1-.565,1.453h0a5.242,5.242,0,0,1-.565.484h-.04a.125.125,0,0,1-.081.04l-3.27,1.857a2.833,2.833,0,0,0-.444.283h0A8.222,8.222,0,0,1,16.064,48.267Z",
    transform: "translate(-6.738 -24.448)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.151 5.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M109.346,38.984H106v-6.3a9.455,9.455,0,0,0-.242-2.584,2.336,2.336,0,0,0-.807-1.13,2.211,2.211,0,0,0-1.373-.4,2.333,2.333,0,0,0-1.413.4,2.171,2.171,0,0,0-.848,1.171,9.431,9.431,0,0,0-.2,2.422v6.419H97.8V33.413a13.832,13.832,0,0,1,.525-4.723,5.19,5.19,0,0,1,1.938-2.382,6.933,6.933,0,0,1,6.782.161,4.843,4.843,0,0,1,1.857,2.7,16.981,16.981,0,0,1,.4,4.36Z",
    transform: "translate(-83.468 -20.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M132.94,13.9a2.045,2.045,0,0,1,1.534.646,2.229,2.229,0,0,1,.646,1.574,1.985,1.985,0,0,1-.646,1.534,1.96,1.96,0,0,1-1.494.646,1.985,1.985,0,0,1-1.534-.646,2.3,2.3,0,0,1-.646-1.574,2.045,2.045,0,0,1,.646-1.534A1.9,1.9,0,0,1,132.94,13.9Z",
    transform: "translate(-103.146 -13.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 3.391,
    height: 13.444,
    transform: "translate(28.098 4.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M144.2,25.6h3.432l3.391,7.953,3.391-7.953h3.432l-5.692,13.484h-2.18Z",
    transform: "translate(-111.136 -20.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M188.952,25.6h3.23V39.044h-3.23v-1.7a6.606,6.606,0,0,1-1.9,1.292,5.065,5.065,0,0,1-2.059.4,5.662,5.662,0,0,1-4.279-1.938,6.681,6.681,0,0,1-1.817-4.764,6.794,6.794,0,0,1,1.736-4.845,5.615,5.615,0,0,1,4.239-1.9,5.553,5.553,0,0,1,4.037,1.736Zm-3.391,2.947A3.231,3.231,0,0,0,183.1,29.6a4.249,4.249,0,0,0,.04,5.45,3.25,3.25,0,0,0,2.463,1.09,3.319,3.319,0,0,0,2.5-1.05,3.888,3.888,0,0,0,1.009-2.745,3.623,3.623,0,0,0-1.009-2.7A3.359,3.359,0,0,0,185.561,28.547Z",
    transform: "translate(-131.827 -20.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M217.3,25.123h2.907v1.736a3.684,3.684,0,0,1,1.252-1.534,2.9,2.9,0,0,1,1.7-.525,3.036,3.036,0,0,1,1.373.363l-1.05,2.907a2.258,2.258,0,0,0-.969-.283,1.565,1.565,0,0,0-1.332.969,8.818,8.818,0,0,0-.525,3.795v6.056H217.3Z",
    transform: "translate(-154.725 -20.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M239.34,13.9a2.045,2.045,0,0,1,1.534.646,2.229,2.229,0,0,1,.646,1.574,1.985,1.985,0,0,1-.646,1.534,1.96,1.96,0,0,1-1.494.646,1.985,1.985,0,0,1-1.534-.646,2.3,2.3,0,0,1-.646-1.574,2.045,2.045,0,0,1,.646-1.534A1.96,1.96,0,0,1,239.34,13.9Z",
    transform: "translate(-166.591 -13.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 3.391,
    height: 13.444,
    transform: "translate(71.093 4.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M265.644,33.33H255.309a3.458,3.458,0,0,0,1.211,2.18,3.842,3.842,0,0,0,2.463.807,4.3,4.3,0,0,0,3.109-1.252l2.7,1.292a6.743,6.743,0,0,1-2.422,2.14,7.747,7.747,0,0,1-3.351.686,6.76,6.76,0,0,1-4.925-1.9,6.513,6.513,0,0,1-1.9-4.764,6.8,6.8,0,0,1,1.9-4.885,6.3,6.3,0,0,1,4.723-1.938,6.568,6.568,0,0,1,4.925,1.938,7.047,7.047,0,0,1,1.9,5.127Zm-3.189-2.543a3.19,3.19,0,0,0-1.251-1.736,3.883,3.883,0,0,0-4.522.081,3.965,3.965,0,0,0-1.171,1.655Z",
    transform: "translate(-175.535 -20.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M290.736,13.8h3.391v4.764h2.019V21.47h-2.019V32.007h-3.391V21.47H289V18.564h1.736Z",
    transform: "translate(-197.479 -13.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M309,25.6h3.432l3.512,8.438,3.835-8.438h3.472l-8.438,18.369h-3.472l2.745-5.935Z",
    transform: "translate(-209.405 -20.836)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.373)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M62.381,17.24h3.391V27.293a6.246,6.246,0,0,0,.242,2.1,1.967,1.967,0,0,0,.848.969,2.774,2.774,0,0,0,1.453.363,2.636,2.636,0,0,0,1.534-.4,2.027,2.027,0,0,0,.888-1.05,7.942,7.942,0,0,0,.242-2.422V17.2h3.391v9.164a15.587,15.587,0,0,1-.283,3.714A5.476,5.476,0,0,1,72.918,32.1a5.359,5.359,0,0,1-1.978,1.453,6.414,6.414,0,0,1-2.584.484,6.254,6.254,0,0,1-3.391-.888,5.143,5.143,0,0,1-2.059-2.22A11.9,11.9,0,0,1,62.3,26.4Z",
    transform: "translate(-62.3 -17.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/dark-logo.a08f59f8993ba8c63c1a1be15c2c4297.svg";
export { ForwardRef as ReactComponent };